/**
 * External Dependencies
 */

import 'jquery';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Collapse from 'bootstrap/js/dist/collapse';
import Mmenu from 'mmenu-light/dist/mmenu-light';
import { addClass, existDomEl, exist, hasClass, readyToAnimate, selectAll } from './utils';
import { TimelineMax, TweenLite, Power4, CSSPlugin, Power2, Sine } from 'gsap/all';

const plugins = [CSSPlugin];

var menuEl = document.getElementById('primary_navigation--js');
if (menuEl) {
  var Menu = new MmenuLight(menuEl, '(max-width: 991px)', 'dark');

  var navigator = Menu.navigation({
    // selectedClass: 'Selected',
    // slidingSubmenus: true,
    // theme: 'dark',
    // title: 'Menu'
  });

  var drawerMenu = Menu.offcanvas({
    position: 'left',
    title: 'Menu',
  });

  //	Open the menu.
  var menuToggler = document.getElementsByClassName('navbar-toggler')[0];
  if (menuToggler) {
    menuToggler.addEventListener('click', function(e) {
      if(hasClass(document.body, 'mm-ocd-opened')) {
        e.preventDefault();
        drawerMenu.close();
      }

      else {
        e.preventDefault();
        drawerMenu.open();
      }
    });
  }
}

const animateBlock = className => {
  const allAnimationBlocks = selectAll(className);
  const TL = new TimelineMax();

  const checkAnim = () => {
    allAnimationBlocks.forEach(block => {
      if (readyToAnimate(block) && !hasClass(block, 'animation-started')) {
        addClass(block, 'animation-started');
        let subAnimations = null;

        if (hasClass(block, 'animated--3')) {
          if (!existDomEl(block.querySelector('.animated-line'))) {
            block.innerHTML = '<span class="animated-line"></span>' + block.innerHTML;
          }

          subAnimations = block.querySelectorAll('li');

          TL.to(block.querySelector('.animated-line'), 6, {
            width: '100%',
            ease: Power4.easeInOut,
          });
        } else {
          subAnimations = block.querySelectorAll('.wp-block-column');
        }
        subAnimations.forEach((anim, index) => {
          if (!existDomEl(anim.querySelector('.animated-subline'))) {
            anim.innerHTML = '<span class="animated-subline"></span>' + anim.innerHTML;
          }

          TL.to(
              anim.querySelector('.animated-subline'),
              2,
              {
                height: '100%',
                width: '100%',
                ease: Power4.easeInOut,
                delay: index === 0 ? 0 : index * 1.5,
              },
              0
            )
              .to(
                anim.querySelector('.animated-subline'),
                1,
                {
                  x: 0,
                  y: 0,
                  ease: Power4.easeInOut,
                  delay: index === 0 ? 0 : index * 1.5,
                },
                0
              )

          if (hasClass(block, 'animated--3')) {
            TL.to(
              anim,
              {
                x: 0,
                duration: 2,
                opacity: 1,
                ease: Power4.easeInOut,
                delay: index === 0 ? 0 : index * 1.5,
              },
              0
            );
          } else {
            TL.to(
                anim.querySelectorAll('p')[0],
                1,
                {
                  x: 0,
                  y: 0,
                  opacity: 1,
                  ease: Power4.easeInOut,
                  delay: index === 0 ? 0 : index * 1.5,
                },
                0
              )
              .to(
                anim.querySelectorAll('p')[1],
                1,
                {
                  x: 0,
                  y: 0,
                  opacity: 1,
                  ease: Power4.easeInOut,
                  delay: index === 0 ? 0 : index * 1.5,
                },
                0
              );
          }
        });
      }
    });
  };

  checkAnim();

  const animationsListener = () => {
    const NAB = selectAll(className);
    const AB = selectAll(className + '.animation-started');

    if (NAB.length === AB.length) {
      document.removeEventListener('scroll', animationsListener, false);
      console.log('animations ended');
    } else {
      checkAnim();
    }
  };

  document.addEventListener('scroll', animationsListener, false);
};

document.addEventListener('DOMContentLoaded', () => {
  if (exist('.animated--1')) {
    animateBlock('.animated--1');
  }

  if (exist('.animated--2')) {
    animateBlock('.animated--2');
  }

  if (exist('.animated--3')) {
    animateBlock('.animated--3');
  }
});

if(exist('.posts-team .single-team-person-text')) {
  let job_title = document.querySelectorAll('.posts-team .single-team-person-text')
  if(window.innerWidth > 768) {
    job_title.forEach(el => {
      if (el.offsetHeight > 25 && el.offsetHeight < 55) {
        el.style.marginBottom = '20px'
      }

      if (el.offsetHeight > 55) {
        el.style.fontSize = '14px'
        if(el.offsetHeight > 43) {
          el.style.marginBottom = '5px'
        }
        else {el.style.marginBottom = '28px'}
      }
    })
  }
}

if(exist('.wp-block-buttons .wp-block-button.is-style-link') || exist('.wp-block-buttons .wp-block-button.is-style-download')) {
  let widths = []
  let buttons_link = document.querySelectorAll('.wp-block-columns.brands .wp-block-button')
  buttons_link.forEach(el => {
    widths.push(el.offsetWidth)
  });

  function max(num){
    return Math.max.apply(null, num);
  }

  let max_el = max(widths)
  buttons_link.forEach(ell => {
    ell.style.width = max_el + 1 + 'px';
  })
}
